import {
    whiteColor,
    boxShadow,
} from '../global';

const homePageStyle = (theme) => ({
    background: {
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        display: 'flex',
        justifyContent: 'center',
    },
    contentDiv: {
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        backgroundColor: (props) => props?.customColor?.screen_background_color || whiteColor,
        borderRadius: '8px',
        justifyContent: 'center',
        ...boxShadow,
    },
    contentDivOrganizer: {
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        backgroundColor: whiteColor,
        borderRadius: '8px',
        justifyContent: 'center',
        ...boxShadow,
    },
    wrapperRight: {
        maxWidth: '100%',
    },
    blackText: {
        margin: '20px',
    },
    middleContent: {
        display: 'contents',
    },
    adsImage: {
        height: '230px',
        [theme.breakpoints.down('xs')]: {
            height: '180px',
        },
        zIndex: '2',
        overflow: 'hidden',
        position: 'relative',
        backgroundPosition: 'center center',
        backgroundSize: 'contain',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        backgroundRepeat: 'no-repeat',
    },
    right: {
        paddingTop: '12px',
        paddingBottom: '12px',
        [theme.breakpoints.up('md')]: {
            paddingTop: '24px',
            paddingBottom: '24px',
        },
    },
    content: {
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
        },
    },
    body: {
        [theme.breakpoints.down('md')]: {
            paddingLeft: '0',
            paddingRight: '0',
        },
    },
    action: {
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
        '& button': {
            margin: '10px 15px 10px 15px',
        },
    },
    divider: {
        [theme.breakpoints.up('md')]: {
            marginLeft: '15px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '-15px',
            marginRight: '-15px',
        },
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '450px !important',
        padding: '10px !important',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '360px !important',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px !important',
            minWidth: '280px !important',
        },
    },
    modifiedRequestButton: {
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
        },
    },
    sectionWrapper: {
        marginBottom: '30px',
    },
    sectionLeft: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    centerContentMd: {
        display: 'flex',
        justifyContent: 'left',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    centerToRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    centerToLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    QACode: {
        position: 'absolute',
        marginTop: '-44px',
        right: '0px',
        backgroundColor: whiteColor,
        padding: '18px',
    },
    commentWrapper: {
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        borderRadius: '8px',
        justifyContent: 'center',
        ...boxShadow,
        marginTop: '35px',
        padding: '10px',
    },
});

export default homePageStyle;
